import { twMerge } from 'tailwind-merge';
import { Card } from '@/components/ui/daisy';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Text from '@/components/ui/custom/dataDisplay/Text';
import {
  QuizCorrectionOption,
  QuizCorrectionStatus,
} from '@/components/question/view/typologies/quiz/useQuizCorrection';
import { QuizAnswerContent } from '@/components/question/view/primitives/shared/QuizAnswerContent';

type CorrectionResultCardProps = {
  option: QuizCorrectionOption;
  label?: string;
};

const cardClasses: Record<QuizCorrectionStatus, string> = {
  correct: 'bg-success-content border-success text-success',
  incorrect: 'bg-error-content border-error text-error',
  missed: 'bg-base-300 border-base-content text-base-content',
};

export function CorrectionResultCard({
  option,
  label,
}: CorrectionResultCardProps) {
  const { answer, status, index } = option;

  return (
    <Card
      className={twMerge(
        'flex w-full flex-row items-center gap-4 border p-4',
        cardClasses[status],
      )}
    >
      <QuizAnswerContent
        answer={answer}
        index={index}
        className={twMerge(
          'flex-1 text-start font-poppins font-600',
          status === 'incorrect' && 'line-through',
        )}
      />
      <ConditionalRenderer condition={!!label}>
        <Text
          text={label ?? ''}
          size="text-sm"
          className={twMerge(
            'shrink-0 font-poppins font-700',
            status === 'missed' && 'opacity-50',
          )}
        />
      </ConditionalRenderer>
    </Card>
  );
}
